import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { extractApiError } from "../api/apiErrorHandler";
import { getNotes } from "api/notesApi";
import { createNotes } from "api/notesApi";
import { showToast } from "components/toast";

const initialState = {
  orderNoteData: [],
  orderNoteLoading: false,
  orderNoteError: null,

  addOrderNoteLoading: false,
  addOrderNoteError: null,

  containerNoteData: [],
  containerNoteLoading: false,
  containerNoteError: null,

  addContainerNoteLoading: false,
  addContainerNoteError: null,
};

// 🔹 Get order Note
export const getOrderNotes = createAsyncThunk(
  "notes/getOrderNotes",
  async (data, thunkAPI) => {
    try {
      return await getNotes(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Get order Note
export const addOrderNotes = createAsyncThunk(
  "notes/addOrderNotes",
  async (data, thunkAPI) => {
    try {
      return await createNotes(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Get container Note
export const getContainerNotes = createAsyncThunk(
  "notes/getContainerNotes",
  async (data, thunkAPI) => {
    try {
      return await getNotes(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Get container Note
export const addContainerNotes = createAsyncThunk(
  "notes/addContainerNotes",
  async (data, thunkAPI) => {
    try {
      return await createNotes(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);

const noteSlice = createSlice({
  name: "notes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // GET ORDER NOTES
    builder
      .addCase(getOrderNotes.pending, (state) => {
        state.orderNoteLoading = true;
        state.orderNoteError = null;
      })
      .addCase(getOrderNotes.fulfilled, (state, action) => {
        state.orderNoteLoading = false;
        state.orderNoteError = null;
        state.orderNoteData = action.payload.data;
      })
      .addCase(getOrderNotes.rejected, (state, action) => {
        state.orderNoteLoading = false;
        state.orderNoteError = action.payload;
      });
    // ADD ORDER NOTES
    builder
      .addCase(addOrderNotes.pending, (state) => {
        state.addOrderNoteLoading = true;
        state.addOrderNoteError = null;
      })
      .addCase(addOrderNotes.fulfilled, (state, action) => {
        state.addOrderNoteLoading = false;
        state.addOrderNoteError = null;
        showToast.success("Order Note added successfully!");
      })
      .addCase(addOrderNotes.rejected, (state, action) => {
        state.addOrderNoteLoading = false;
        state.addOrderNoteError = action.payload;
        showToast.error(state.addOrderNoteError);
      });

    // GET CONTAINER NOTES
    builder
      .addCase(getContainerNotes.pending, (state) => {
        state.containerNoteLoading = true;
        state.containerNoteError = null;
      })
      .addCase(getContainerNotes.fulfilled, (state, action) => {
        state.containerNoteLoading = false;
        state.containerNoteError = null;
        state.containerNoteData = action.payload.data;
      })
      .addCase(getContainerNotes.rejected, (state, action) => {
        state.containerNoteLoading = false;
        state.containerNoteError = action.payload;
      });
    // ADD CONTAINER NOTES
    builder
      .addCase(addContainerNotes.pending, (state) => {
        state.addContainerNoteLoading = true;
        state.addContainerNoteError = null;
      })
      .addCase(addContainerNotes.fulfilled, (state, action) => {
        state.addContainerNoteLoading = false;
        state.addContainerNoteError = null;
        showToast.success("Container Note added successfully!");
      })
      .addCase(addContainerNotes.rejected, (state, action) => {
        state.addContainerNoteLoading = false;
        state.addContainerNoteError = action.payload;
        showToast.error(state.addContainerNoteError);
      });
  },
});

export default noteSlice.reducer;
